<div class="bgf-page reports-page">
    <section class="reports-shell" [ngClass]="{ 'bgf-loading bgf-loading--color': fetching }">
        <div class="reports-shell__header">
            <div class="reports-title-block">
                <span class="reports-title-block__icon">
                    <i class="fa-solid fa-chart-pie"></i>
                </span>
                <div class="reports-title-block__copy">
                    <h1>Riportok</h1>
                    <p *ngIf="overview as data">
                        {{ data.range.day_count | number:'1.0-0' }} napos időszak elemzése.
                    </p>
                    <p *ngIf="!overview">
                        Rendelés alapú kimutatások: forgalom, workflow, teljesítési és operatív mutatók.
                    </p>
                </div>
            </div>

            <div class="reports-shell__meta">
                <span class="reports-meta-pill" *ngIf="overview?.generated_at as generatedAt">
                    <i class="fa-regular fa-clock"></i>
                    Frissítve: {{ generatedAt | date:'yyyy.MM.dd HH:mm' }}
                </span>
                <span class="reports-meta-pill reports-meta-pill--scope">
                    <i class="fa-solid fa-filter"></i>
                    {{ getScopeLabel(archivedScope) }}
                </span>
                <span class="reports-meta-pill" *ngIf="overview as data">
                    <i class="fa-regular fa-calendar-days"></i>
                    {{ data.range.from | date:'yyyy.MM.dd' }} - {{ data.range.to | date:'yyyy.MM.dd' }}
                </span>
            </div>
        </div>

        <form class="reports-filters" [formGroup]="filterFormGroup">
            <div class="filter-pill filter-pill--range">
                <i class="fa-regular fa-calendar"></i>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="from" placeholder="Kezdő dátum" (dateChange)="onFiltersChanged()">
                    <input matEndDate formControlName="to" placeholder="Záró dátum" (dateChange)="onFiltersChanged()">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </div>

            <div class="scope-switch" role="tablist" aria-label="Riport adatkör választó">
                <button
                    type="button"
                    [class.is-active]="archivedScope === 'active'"
                    (click)="setArchivedScope('active')"
                >
                    Aktív
                </button>
                <button
                    type="button"
                    [class.is-active]="archivedScope === 'archived'"
                    (click)="setArchivedScope('archived')"
                >
                    Archív
                </button>
                <button
                    type="button"
                    [class.is-active]="archivedScope === 'all'"
                    (click)="setArchivedScope('all')"
                >
                    Mind
                </button>
            </div>
        </form>

        <p class="reports-error" *ngIf="loadError">{{ loadError }}</p>

        <ng-container *ngIf="overview as data">
            <div class="reports-kpi-grid">
                <article class="kpi-card">
                    <span class="kpi-card__label">Rendelések</span>
                    <strong class="kpi-card__value">{{ data.totals.orders | number:'1.0-0' }}</strong>
                    <small>
                        Aktív: {{ data.totals.active_orders | number:'1.0-0' }}
                        · Archív: {{ data.totals.archived_orders | number:'1.0-0' }}
                    </small>
                </article>

                <article class="kpi-card">
                    <span class="kpi-card__label">Árbevétel</span>
                    <strong class="kpi-card__value" *ngIf="!data.totals.multi_currency; else mixedRevenueValue">
                        {{ data.totals.revenue | number:'1.0-0' }} {{ data.totals.currency_code }}
                    </strong>
                    <ng-template #mixedRevenueValue>
                        <strong class="kpi-card__value">Vegyes pénznem</strong>
                    </ng-template>
                    <small *ngIf="!data.totals.multi_currency">Időszaki összegzett rendelésérték</small>
                    <small *ngIf="data.totals.multi_currency">Pénznemenként bontott árbevétel</small>
                    <div class="kpi-card__currency-list" *ngIf="data.totals.multi_currency">
                        <span *ngFor="let currency of data.totals.revenue_by_currency">
                            {{ currency.revenue | number:'1.0-0' }} {{ currency.currency_code }}
                        </span>
                    </div>
                </article>

                <article class="kpi-card">
                    <span class="kpi-card__label">Átlag kosár</span>
                    <strong class="kpi-card__value" *ngIf="!data.totals.multi_currency; else mixedAverageValue">
                        {{ data.totals.average_order_value | number:'1.0-0' }} {{ data.totals.currency_code }}
                    </strong>
                    <ng-template #mixedAverageValue>
                        <strong class="kpi-card__value">Pénznemenként eltérő</strong>
                    </ng-template>
                    <small *ngIf="!data.totals.multi_currency">Átlagos rendelésérték</small>
                    <small *ngIf="data.totals.multi_currency">Átlag kosár pénznemenként</small>
                    <div class="kpi-card__currency-list" *ngIf="data.totals.multi_currency">
                        <span *ngFor="let currency of data.totals.revenue_by_currency">
                            {{ currency.average_order_value | number:'1.0-0' }} {{ currency.currency_code }}
                        </span>
                    </div>
                </article>

                <article class="kpi-card">
                    <span class="kpi-card__label">Szállítási készültség</span>
                    <strong class="kpi-card__value" [ngClass]="getHealthClass(data.totals.shipped_rate)">
                        {{ data.totals.shipped_rate | number:'1.0-1' }}%
                    </strong>
                    <small>Feladott rendelések aránya</small>
                </article>

                <article class="kpi-card">
                    <span class="kpi-card__label">Csomagolás kész</span>
                    <strong class="kpi-card__value" [ngClass]="getHealthClass(data.totals.packaging_ready_rate)">
                        {{ data.totals.packaging_ready_rate | number:'1.0-1' }}%
                    </strong>
                    <small>Csomagolásra kész állapot aránya</small>
                </article>

                <article class="kpi-card">
                    <span class="kpi-card__label">Dokumentum lefedettség</span>
                    <div class="kpi-card__double">
                        <span>
                            Címke
                            <strong [ngClass]="getHealthClass(data.totals.label_coverage_rate)">
                                {{ data.totals.label_coverage_rate | number:'1.0-1' }}%
                            </strong>
                        </span>
                        <span>
                            Számla
                            <strong [ngClass]="getHealthClass(data.totals.invoice_coverage_rate)">
                                {{ data.totals.invoice_coverage_rate | number:'1.0-1' }}%
                            </strong>
                        </span>
                    </div>
                    <small>Sztornó számlák: {{ data.totals.cancelled_invoice_count | number:'1.0-0' }}</small>
                </article>
            </div>

            <div class="reports-empty" *ngIf="data.totals.orders === 0">
                <span class="reports-empty__icon"><i class="fa-solid fa-chart-line"></i></span>
                <h2>Nincs adat a kiválasztott időszakban</h2>
                <p>Próbálj hosszabb dátumtartományt vagy másik adatkört (Aktív / Archív / Mind) választani.</p>
            </div>

            <ng-container *ngIf="data.totals.orders > 0">
                <div class="reports-main-grid">
                    <article class="report-card report-card--timeline">
                        <div class="report-card__head">
                            <h2>Napi trend</h2>
                            <div class="report-card__legend">
                                <span><i class="legend-dot legend-dot--orders"></i>Rendelés db</span>
                                <span><i class="legend-dot legend-dot--revenue"></i>Árbevétel</span>
                            </div>
                        </div>

                        <div class="timeline-chart" *ngIf="data.timeline.length; else noTimeline">
                            <div class="timeline-point" *ngFor="let point of data.timeline; trackBy: trackByTimelineDay">
                                <div class="timeline-point__bars">
                                    <span
                                        class="timeline-bar timeline-bar--orders"
                                        [style.height.%]="getTrendHeight(point.order_count, trendMaxOrders)"
                                    ></span>
                                    <span
                                        class="timeline-bar timeline-bar--revenue"
                                        [style.height.%]="getTrendHeight(point.revenue, trendMaxRevenue)"
                                    ></span>
                                </div>
                                <span class="timeline-point__label">{{ point.date | date:'MM.dd' }}</span>
                            </div>
                        </div>

                        <ng-template #noTimeline>
                            <p class="report-card__empty">Nincs trend adat.</p>
                        </ng-template>
                    </article>

                    <article class="report-card">
                        <div class="report-card__head">
                            <h2>Workflow státuszok</h2>
                            <span class="report-card__note">Rendelés életciklus megoszlás</span>
                        </div>

                        <div class="breakdown-list" *ngIf="data.workflow.length; else noWorkflow">
                            <div class="breakdown-item" *ngFor="let item of data.workflow">
                                <div class="breakdown-item__meta">
                                    <span>{{ getWorkflowLabel(item.status) }}</span>
                                    <strong>{{ item.count | number:'1.0-0' }} ({{ item.share | number:'1.0-1' }}%)</strong>
                                </div>
                                <div class="breakdown-item__meter">
                                    <span [style.width.%]="item.share"></span>
                                </div>
                            </div>
                        </div>

                        <ng-template #noWorkflow>
                            <p class="report-card__empty">Nincs elérhető státuszadat.</p>
                        </ng-template>
                    </article>
                </div>

                <div class="reports-main-grid reports-main-grid--secondary">
                    <article class="report-card">
                        <div class="report-card__head">
                            <h2>Top piacterek</h2>
                            <span class="report-card__note">Rendelésszám és részesedés</span>
                        </div>

                        <div class="breakdown-list" *ngIf="data.merchants.length; else noMerchants">
                            <div class="breakdown-item" *ngFor="let item of data.merchants">
                                <div class="breakdown-item__meta">
                                    <span>{{ item.merchant_name }}</span>
                                    <strong>
                                        {{ item.order_count | number:'1.0-0' }} db ·
                                        <ng-container *ngIf="!data.totals.multi_currency; else mixedMerchantRevenue">
                                            {{ item.revenue | number:'1.0-0' }} {{ data.totals.currency_code }}
                                        </ng-container>
                                        <ng-template #mixedMerchantRevenue>vegyes pénznem</ng-template>
                                    </strong>
                                </div>
                                <div class="breakdown-item__meter">
                                    <span [style.width.%]="item.share"></span>
                                </div>
                            </div>
                        </div>

                        <ng-template #noMerchants>
                            <p class="report-card__empty">Nincs piactér adat.</p>
                        </ng-template>
                    </article>

                    <article class="report-card">
                        <div class="report-card__head">
                            <h2>Top országok</h2>
                            <span class="report-card__note">Rendelésszám és részesedés</span>
                        </div>

                        <div class="breakdown-list" *ngIf="data.countries.length; else noCountries">
                            <div class="breakdown-item" *ngFor="let item of data.countries">
                                <div class="breakdown-item__meta">
                                    <span>{{ item.country }}</span>
                                    <strong>
                                        {{ item.order_count | number:'1.0-0' }} db ·
                                        <ng-container *ngIf="!data.totals.multi_currency; else mixedCountryRevenue">
                                            {{ item.revenue | number:'1.0-0' }} {{ data.totals.currency_code }}
                                        </ng-container>
                                        <ng-template #mixedCountryRevenue>vegyes pénznem</ng-template>
                                    </strong>
                                </div>
                                <div class="breakdown-item__meter">
                                    <span [style.width.%]="item.share"></span>
                                </div>
                            </div>
                        </div>

                        <ng-template #noCountries>
                            <p class="report-card__empty">Nincs ország bontás.</p>
                        </ng-template>
                    </article>
                </div>

                <div class="reports-main-grid reports-main-grid--secondary">
                    <article class="report-card report-card--products">
                        <div class="report-card__head">
                            <h2>Top termékek</h2>
                            <span class="report-card__note">Legnagyobb mennyiség alapján</span>
                        </div>

                        <div class="top-products" *ngIf="data.top_products.length; else noProducts">
                            <div class="top-products__head">
                                <span>Termék</span>
                                <span>Mennyiség</span>
                                <span>Bevétel</span>
                            </div>
                            <div class="top-products__row" *ngFor="let product of data.top_products">
                                <div class="top-products__title">
                                    <strong>{{ product.name }}</strong>
                                    <small>SKU: {{ product.sku }}</small>
                                </div>
                                <span>{{ product.quantity | number:'1.0-0' }}</span>
                                <span *ngIf="!data.totals.multi_currency; else mixedProductRevenue">
                                    {{ product.revenue | number:'1.0-0' }} {{ data.totals.currency_code }}
                                </span>
                                <ng-template #mixedProductRevenue>
                                    <span>vegyes</span>
                                </ng-template>
                            </div>
                        </div>

                        <ng-template #noProducts>
                            <p class="report-card__empty">Nincs termék kimutatás.</p>
                        </ng-template>
                    </article>

                    <article class="report-card">
                        <div class="report-card__head">
                            <h2>Figyelmeztetések</h2>
                            <span class="report-card__note">Azonnali operatív teendők</span>
                        </div>

                        <div class="attention-grid">
                            <article class="attention-item attention-item--danger">
                                <span>Lejárt határidő</span>
                                <strong>{{ data.attention.overdue_orders | number:'1.0-0' }}</strong>
                                <small>Nem feladott, de határidőn túli rendelések</small>
                            </article>

                            <article class="attention-item attention-item--warning">
                                <span>Hiányzó címke</span>
                                <strong>{{ data.attention.missing_label_orders | number:'1.0-0' }}</strong>
                                <small>Nyitott rendelés címke nélkül</small>
                            </article>

                            <article class="attention-item attention-item--warning">
                                <span>Hiányzó számla</span>
                                <strong>{{ data.attention.missing_invoice_orders | number:'1.0-0' }}</strong>
                                <small>Nyitott rendelés számla nélkül</small>
                            </article>

                            <article class="attention-item attention-item--neutral">
                                <span>Határidő nélkül</span>
                                <strong>{{ data.attention.no_deadline_orders | number:'1.0-0' }}</strong>
                                <small>Feladási dátum nélküli rendelések</small>
                            </article>
                        </div>
                    </article>
                </div>
            </ng-container>
        </ng-container>
    </section>
</div>
